<script setup>
import HeadlineComponent from "./Headline.vue";
import {inject} from "vue";
import PageTransition from "./PageTransition.vue";
import {useRouter} from "vue-router";

const props = defineProps({
    title: String,
    image: { type: String, required: false, default: null },
    previousIndex: Number,
    nextIndex: Number,
    inputValues: Object,
    isTopReturn: { type: Boolean, required: false, default: false },
});

const index = inject('index');
const router = useRouter();

const DESCRIPTION = "LINEやFacebook、Appleのアカウントと事前に連携していた場合、それら外部アカウントの認証により、データ復旧が可能です。\n\n以下の手順をお試しください。";
const SELECTION_TEXT = "解決しない場合はこちら";

const emit = defineEmits(['changeIndex', 'resetInputValue']);

// 「解決しない場合はこちら」は押下で即遷移（リンク的挙動）
function navigateToNext() {
    emit('changeIndex', props.nextIndex, props.title, SELECTION_TEXT);
    router.push('/form/' + props.nextIndex);
}
</script>

<template>
    <div class="uk-margin-small-left uk-margin-small-right uk-flex-1">
        <div class="uk-flex uk-flex-column uk-height-1-1">
            <headline-component v-if="props.title" :title="props.title"/>
            <div class="uk-margin-bottom description-text">
                <span style="white-space: pre-wrap;">{{ DESCRIPTION }}</span>
            </div>
            <div class="uk-flex uk-flex-center uk-flex-1" style="overflow-y: auto; align-items: flex-start;">
                <img v-if="image" :src="image" alt="" class="uk-width-1-1" style="height: auto;"/>
            </div>
            <div class="uk-flex uk-width-medium uk-margin-auto uk-text-left uk-margin-top uk-margin-bottom">
                <label class="uk-margin-bottom uk-width-1 uk-text-center" @click="navigateToNext">
                    <span style="white-space: pre-wrap;">
                        {{ SELECTION_TEXT }}
                    </span>
                </label>
            </div>
            <page-transition
                @reset-input-value="(idx) => { $emit('resetInputValue', idx); }"
                :index="index"
                :previous-index="previousIndex"
                :next-index="nextIndex"
                :input-key="title"
                :is-active-button="false"
                :is-top-return="isTopReturn"
                :show-next-button="false"
            ></page-transition>
        </div>
    </div>
</template>

<style scoped>
.description-text {
    font-size: 1rem;
}

label {
    font-size: 1.1rem;
    padding: 5px 20px;
    background-color: #fff;
    border: 2px solid #257cde;
    border-radius: 50px;
    cursor: pointer;
    &:hover {
        border: 3px solid #257cde;
        padding: 4px 20px;
    }
}
</style>
